import { AuctionServiceType } from 'store/shared/api/graph/interfaces/types';
import { EnumTranslationMap } from 'utils/formUtils';

export const auctionServiceTypeTranslationMap: EnumTranslationMap<typeof AuctionServiceType> = {
  FIXED: 'fixed',
  TIERED: 'tiered',
};
